import React, { useState } from "react";

import { pageTitle } from "../PageTitle";

import HeaderOne from "../Header/HeaderOne";

import FooterOne from "../Footer/FooterOne";
import aiAccounting from "./../../assets/images/banner/ai-accounting.png";
import { Link, useLocation } from "react-router-dom";

const AI_Accounting_Finance = () => {
  pageTitle("RPA in finance");

  const [formData, setFormData] = useState({
    name: "",

    email: "",

    subject: "",

    phone: "",

    message: "",
  });

  const location = useLocation();

  const pathnames = location.pathname.split("/").filter((x) => x);

  const handleSubmit = (e) => {
    e.preventDefault();

    // Your logic to handle form submission goes here

    console.log("Form submitted:", formData);

    // Clear the form fields after submission if needed

    setFormData({
      name: "",

      email: "",

      subject: "",

      phone: "",

      message: "",
    });
  };

  const servicesData = [
    { id: 1, title: "AI_Accounting_Finance", slug: "/AI_Accounting_Finance" },
    { id: 2, title: "AI-Audit-Compliance", slug: "/AI-Audit-Compliance" },
    { id: 3, title: "AI-Human-Resources", slug: "/AI-Human-Resources" },
    { id: 4, title: "AI-Operations", slug: "/AI-Operations" },
  ];

  const renderServices = () => {
    return servicesData.map((service) => (
      <li
        key={service.id}
        className={service.slug === "/content-marketing" ? "active" : ""}
      >
        <Link to={service.slug}>{service.title}</Link>
      </li>
    ));
  };

  return (
    <>
      <HeaderOne></HeaderOne>
      <div className="ai-overlay-wrapper">
        <img
          src={aiAccounting}
          alt="AI Operations"
          className="img-fluid"
        />
      
        <div className="ai-overlay">
          <h2>AI Accounting and Finance</h2>
        </div>
      </div>

      {/* RPA Accounting Impact Section */}
      <section className="rpa-af-section">
        <div className="container">
          {/* FULL WIDTH INTRO */}
          <div className="row">
            <div className="col-12">
              <div className="rpa-af-content">
                <h2 className="rpa-af-title">
                  RPA for Accounting and Finance Processes
                </h2>

                <p className="rpa-af-desc">
                  <span className="rpa-af-dropcap">T</span>
                  hough{" "}
                  <span className="rpa-af-highlight">
                    Robotic Process Automation
                  </span>{" "}
                  (RPA) is making a sweeping impact on businesses across the
                  board, there are certain industries and functions that are
                  more susceptible for a software automation implementation.
                  Accounting and finance, encompassing various manual and
                  repetitive processes, is one of the major automation-prone
                  business functions today.
                </p>
              </div>
            </div>
          </div>

          {/* TWO COLUMN SECTION */}
          <div className="row align-items-start mt-4">
            {/* LEFT CONTENT */}
            <div className="col-lg-8">
              <h3 className="rpa-af-subtitle">What’s the Impact?</h3>

              <p className="rpa-af-desc">
                Between payroll processing, invoices, procurement, and
                reporting, various mundane tasks bog down accounting and finance
                departments on a daily basis. This significantly hinders human
                capital and innovative thinking within these departments and
                makes repetitive tasks more susceptible to human error.
              </p>
              <p className="rpa-af-desc mt-3">
                An RPA implementation can close the financial digitization gaps
                present within many organizations, reducing employee turnover
                and costs while increasing ROI. An implementation also enables
                the accounting and finance team to play a part in your RPA
                Center of Excellence (CoE), which is especially impactful for
                customer-facing department representatives.
              </p>
            </div>

            {/* RIGHT CARD */}
            <div className="col-lg-4">
              <div className="rpa-af-stats-card">
                <div className="rpa-af-stats-row">
                  <div className="rpa-af-stat">
                    <div className="rpa-af-icon">
                      <i className="fa-solid fa-clock"></i>
                    </div>
                    <div>
                      <h4>85%</h4>
                      <p>Time Saved</p>
                    </div>
                  </div>

                  <div className="rpa-af-stat">
                    <div className="rpa-af-icon">
                      <i className="fa-solid fa-sack-dollar"></i>
                    </div>
                    <div>
                      <h4>$60,000</h4>
                      <p>Cost Savings</p>
                    </div>
                  </div>
                </div>

                <p className="rpa-af-case-text">
                  Our fast-food franchise restaurant client automated these key
                  accounting functions across their 800+ stores:
                </p>

                <ul className="rpa-af-case-list">
                  <li>Financial reconciliation processes</li>
                  <li>Invoice and payment processing</li>
                  <li>Daily and monthly reporting</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* RPA Use Cases Section */}
      <section className="rpa-uc-section">
        <div className="container">
          <div className="row align-items-center">
            {/* LEFT GRADIENT CARD */}
            <div className="col-lg-4">
              <div className="rpa-uc-card">
                <div className="rpa-uc-card-icon">
                  <i className="fa-solid fa-briefcase"></i>
                </div>

                <h3 className="rpa-uc-card-title">
                  Digitizing Accounting and
                  <br />
                  Finance Operations
                </h3>

                <ul className="rpa-uc-card-list">
                  <li>Improve productivity</li>
                  <li>Reduce operational costs</li>
                  <li>Maintain compliance</li>
                  <li>Ignite innovation by reducing stagnancy</li>
                </ul>
              </div>
            </div>

            {/* RIGHT CONTENT */}
            <div className="col-lg-8">
              <div className="rpa-uc-content">
                <h2 className="rpa-uc-heading">
                  RPA Use Cases for Accounting and Finance Automation
                </h2>

                <ul className="rpa-uc-list">
                  <li>
                    <strong>Invoice Processing:</strong> Extract information
                    from vendor invoices and purchase orders without human
                    intervention.
                  </li>

                  <li>
                    <strong>Payment Processing:</strong> Automate payment
                    validation and reconciliation while staying notified of all
                    important details.
                  </li>

                  <li>
                    <strong>Customer Onboarding:</strong> Automate the process
                    of onboarding new customer data such as forms, invoices, and
                    sales orders.
                  </li>

                  <li>
                    <strong>Tracking Compliance Mandates:</strong> Respond and
                    track changing compliance mandates while maintaining
                    accurate reporting.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <FooterOne></FooterOne>
    </>
  );
};

export default AI_Accounting_Finance;
